import styled from "styled-components";
import color from "../../../assets/css/colors";

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 35px;
`

export const Box = styled.div``

export const ContainerButton = styled.div`
    width: 150px;
    padding: 8px;
`

export const LogoBackground = styled.div`
    width: 97px;
    height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px;
    background-color: #F2F1FA;
    border-radius: 8px;
`

export const Logo = styled.img`
    max-width: 75px;
    max-height: 73px;
    height: auto;
    width: auto;
    object-fit: contain;
    background-color: #FFF;
    border-radius: 5px;
`

export const DropzoneContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 35px;
`

export const ContainerTitle = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    color: #454546;
    margin-bottom: 21px;
`

export const TranparentButton = styled.button`
    font: normal normal normal 11px/15px Circular Std Book;
    color: #F58B1E;
    background-color: #FFF;
    border: 0px;
    outline: 0px;

    &:focus{
        outline: 0;
    }
`;

export const ButtonContainerForLargeDevices = styled.div`
    width: 100%;
    margin: 45px 0;

    button {
        padding: 9px;
    }

    @media (max-width: 992px) {
        display: none;
    }
`;

export const ButtonContainerForSmallDevices = styled.div`
    width: 100%;
    display: none;

    margin: 45px 0;

    button {
        padding: 9px;
    }

    @media (max-width: 992px) {
        display: block;
    }
`;

export const FieldLabel = styled.label`
    font-size: 14px;
`

export const TextDescription = styled.p`
    font-size: 14px;
    font-weight: normal ;
`

export const FlexBox = styled.div`
    display: flex;
`

export const ContainerInputColor = styled.div`
    margin-right: 30px;
    .color {
        padding: 0.1em 0.4em 0.1em;
        margin-bottom: 27px;
    }
`

export const Textarea = styled.textarea`
    width: 100%;
    position: relative;
    height: 100px;
    resize: none;
    background: ${color.white};
    color: ${color.tertiary};
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 1.2em 1em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;
    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }
    &:focus {
        color: var(--gray);
        border: 1px solid ${color.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }
    &:disabled {
        background-color: ${color.grayLightest};
    }
    &::-webkit-input-placeholder {
        text-transform: none;
    }
    &:-moz-placeholder {
        text-transform: none;
    }
    &::-moz-placeholder {
        text-transform: none;
    }
    &:-ms-input-placeholder {
        text-transform: none;
    }
    &::placeholder {
        text-transform: none;
    }
`;

export const ContainerTextArea = styled.div`
    position: relative;
    display: flex;
    align-items: start;
    font-size: 14px;
    color: ${color.grayDark};
`

export const LengthTextArea = styled.span`
    color: ${color.primary};
    font-size: 14px;
`